import { useWatch } from '@graphcommerce/ecommerce-ui';
import { getProductTierPrice, ProductPageItemFragment, useFormAddProductsToCart } from '@graphcommerce/magento-product'
import { Money } from '@graphcommerce/magento-store'
import { useConfigurableOptionsSelection } from '@graphcommerce/magento-product-configurable/hooks/useConfigurableOptionsSelection'
import {Box} from '@mui/material'
import { useCustomerPrices } from '../../hooks/useCustomerPrices'

type ConfigurablePriceProps = {
  product: ProductPageItemFragment
  index?: number
}

export function ConfigurablePrice(props: ConfigurablePriceProps) {
  const { product,  index = 0 } = props
  const { configured } = useConfigurableOptionsSelection({ url_key: product.url_key, index })
  // const { control } = useFormAddProductsToCart();
  // const quantity = useWatch({ control, name: `cartItems.${index}.quantity` });

  const regular_price =
    configured?.configurable_product_options_selection?.variant?.price_range.minimum_price.regular_price
      ?? product.price_range?.minimum_price.regular_price
  // const price_tiers = configured?.configurable_product_options_selection?.variant?.price_tiers
  // const final_price = getProductTierPrice({ price_tiers }, quantity) ??  configured?.configurable_product_options_selection?.variant?.price_range.minimum_price.final_price
  //  ?? product.price_range?.minimum_price.final_price

  // const price = getProductTierPrice({ price_tiers }, quantity) ?? regular_price;
  const customerPrices = useCustomerPrices({url_key: product.url_key, variant_url_key: configured?.configurable_product_options_selection?.variant?.url_key})

  if (!customerPrices) return null

  const { final_price, special_price } = customerPrices
  const { value: customerFinalPriceValue } = final_price
  const customerFinalPriceExclTax = {...final_price}
  customerFinalPriceExclTax.value = Number(customerFinalPriceValue) / 1.21

  return (
    <Box component='div'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: '.5rem'
      }}
    >
      <Money {...customerFinalPriceExclTax} />
      <Box
        component='span'
        sx={{
          display: 'inline-block',
          textDecoration: special_price ? 'line-through' : 'none',
          color: 'text.disabled',
          fontSize: '1rem',
        }}
      >
        PVR: <Money {...regular_price} />
      </Box>
      {(special_price) && (
        <Box
          component='span'
          sx={{
            display: 'inline-block',
            color: 'text.disabled',
            fontSize: '1rem',
          }}
        >
          PVR: <Money {...special_price} />
        </Box>
      )}
    </Box>
  )

  // return <Money {...price} />
}
